var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotebooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1249px",
    height: "583px",
    viewBox: "0 0 1249 583",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notebooks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notebooks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.785714, 361.333333)",
    id: "book/junior/landscape"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.000000, 32.500000) rotate(-270.000000) translate(-42.000000, -32.500000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-16",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    transform: "translate(42.000000, 32.500000) rotate(90.000000) translate(-42.000000, -32.500000) ",
    points: "74 74 10 74 10 -9 74 -9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc-6/red",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#562C2C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 0,
    y: 57.5833333,
    width: 14,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 46.75,
    width: 14,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 35.9166667,
    width: 14,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 0,
    y: 25.0833333,
    width: 14,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 14.25,
    width: 14,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 3.41666667,
    width: 14,
    height: 4,
    rx: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(553.285714, 408.000000)",
    id: "book/tall/portrait"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    strokeOpacity: 0.25,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.04,
    fill: "#000000",
    points: "65 167 1 167 1 1 65 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    x: 4,
    y: 163,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    x: 4,
    y: 155,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    x: 4,
    y: 147,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    x: 4,
    y: 139,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    x: 4,
    y: 131,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    x: 4,
    y: 123,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    x: 4,
    y: 115,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 4,
    y: 107,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 4,
    y: 99,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 4,
    y: 91,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 4,
    y: 83,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 4,
    y: 75,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 4,
    y: 67,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 4,
    y: 59,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 4,
    y: 51,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 4,
    y: 43,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 4,
    y: 35,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 4,
    y: 27,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 4,
    y: 19,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 4,
    y: 11,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 3,
    width: 6,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1075.000000, 312.000000)",
    id: "book/tall/landscape-copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    transform: "translate(83.000000, 33.000000) rotate(90.000000) translate(-83.000000, -33.000000) ",
    points: "115 116 51 116 51 -50 115 -50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 5.28571429,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 7,
    y: 44.5714286,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 7,
    y: 12.3571429,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 7,
    y: 51.6428571,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 7,
    y: 19.4285714,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 7,
    y: 58.7142857,
    width: 7,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.928571, 171.666667)",
    id: "book/half/portrait-copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    transform: "translate(42.000000, 64.500000) rotate(90.000000) translate(-42.000000, -64.500000) ",
    x: -22,
    y: 23,
    width: 128,
    height: 83
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/coptic-cover/red",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#0E9594"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 11.2857143,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 7,
    y: 88.0714286,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 7,
    y: 25.1071429,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 7,
    y: 101.892857,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 7,
    y: 38.9285714,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 7,
    y: 115.714286,
    width: 7,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(804.928571, 310.833333)",
    id: "book/half/landscape-copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.500000, 43.000000) rotate(-270.000000) translate(-64.500000, -43.000000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    strokeOpacity: 0.25,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.04,
    fill: "#000000",
    transform: "translate(65.000000, 43.000000) rotate(90.000000) translate(-65.000000, -43.000000) ",
    points: "106.5 -21 106.5 107 23.5 107 23.5 -21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/spiral/red",
    transform: "translate(-7.000000, 0.500000)",
    fill: "#0E9594"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    x: 4,
    y: 81.9761905,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    x: 4,
    y: 73.8809524,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    x: 4,
    y: 65.7857143,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    x: 4,
    y: 57.6904762,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 4,
    y: 49.5952381,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 4,
    y: 41.5,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 4,
    y: 33.4047619,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 4,
    y: 25.3095238,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 4,
    y: 17.2142857,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 4,
    y: 9.11904762,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 1.02380952,
    width: 6,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(779.714286, 1.000000)",
    id: "book/tall/landscape-copy-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    strokeOpacity: 0.25,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.04,
    fill: "#000000",
    transform: "translate(83.000000, 33.000000) rotate(90.000000) translate(-83.000000, -33.000000) ",
    points: "115 116 51 116 51 -50 115 -50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#562C2C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/japanese/red",
    transform: "translate(0.466667, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.53333333,
    y: 4.5,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 6.53333333,
    y: 22.5714286,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 6.53333333,
    y: 40.6428571,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 6.53333333,
    y: 58.7142857,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 11.1333333,
    y: 0,
    width: 2,
    height: 66
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1157.000000, 1.000000)",
    id: "book/junior/landscape-copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-16",
    strokeOpacity: 0.3,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.06,
    fill: "#000000",
    transform: "translate(42.000000, 32.500000) rotate(90.000000) translate(-42.000000, -32.500000) ",
    points: "74 74 10 74 10 -9 74 -9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    x: 4,
    y: 62.452381,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    x: 4,
    y: 59.3571429,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    x: 4,
    y: 56.2619048,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    x: 4,
    y: 53.1666667,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    x: 4,
    y: 50.0714286,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    x: 4,
    y: 46.9761905,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    x: 4,
    y: 43.8809524,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 4,
    y: 40.7857143,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 4,
    y: 37.6904762,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 4,
    y: 34.5952381,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 4,
    y: 31.5,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 4,
    y: 28.4047619,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 4,
    y: 25.3095238,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 4,
    y: 22.2142857,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 4,
    y: 19.1190476,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 4,
    y: 16.0238095,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 4,
    y: 12.9285714,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 4,
    y: 9.83333333,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 4,
    y: 6.73809524,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 4,
    y: 3.64285714,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 0.547619048,
    width: 6,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(503.428571, 1.000000)",
    id: "book/half/landscape-copy-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    transform: "translate(65.000000, 43.000000) rotate(90.000000) translate(-65.000000, -43.000000) ",
    points: "106.5 -21 106.5 107 23.5 107 23.5 -21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/spiral/red",
    transform: "translate(-7.000000, 0.500000)",
    fill: "#0E9594"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    x: 4,
    y: 81.9761905,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    x: 4,
    y: 77.9285714,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    x: 4,
    y: 73.8809524,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    x: 4,
    y: 69.8333333,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    x: 4,
    y: 65.7857143,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    x: 4,
    y: 61.7380952,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    x: 4,
    y: 57.6904762,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 4,
    y: 53.6428571,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 4,
    y: 49.5952381,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 4,
    y: 45.547619,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 4,
    y: 41.5,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 4,
    y: 37.452381,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 4,
    y: 33.4047619,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 4,
    y: 29.3571429,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 4,
    y: 25.3095238,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 4,
    y: 21.2619048,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 4,
    y: 17.2142857,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 4,
    y: 13.1666667,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 4,
    y: 9.11904762,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 4,
    y: 5.07142857,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 1.02380952,
    width: 6,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(916.285714, 109.500000)",
    id: "book/full/portrait-copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.500000, 84.000000) rotate(-270.000000) translate(-64.500000, -84.000000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    strokeOpacity: 0.3,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.06,
    fill: "#000000",
    points: "1 1 129 1 129 167 1 167 1 31.0158824"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/coptic-cover/red",
    transform: "translate(-8.000000, 0.000000)",
    fill: "#562C2C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8,
    y: 15,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 8,
    y: 115,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 8,
    y: 33,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 8,
    y: 133,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 8,
    y: 51,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 8,
    y: 151,
    width: 8,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1112.000000, 102.000000)",
    id: "book/full/portrait-copy-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    strokeOpacity: 0.25,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.04,
    fill: "#000000",
    points: "1 1 129 1 129 167 1 167 1 31.0158824"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-8.000000, 0.000000)",
    fill: "#0E9594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/japanese/red",
    transform: "translate(0.533333, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7.46666667,
    y: 13,
    width: 7.46666667,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 7.46666667,
    y: 59,
    width: 7.46666667,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 7.46666667,
    y: 105,
    width: 7.46666667,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 7.46666667,
    y: 151,
    width: 7.46666667,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 12.8666667,
    y: 0,
    width: 2,
    height: 168
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.642857, -8.000000)",
    id: "book/junior/portrait-copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.500000, 42.000000) rotate(-270.000000) translate(-32.500000, -42.000000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-16",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    points: "65 84 1 84 1 1 65 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#0E9594"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 2,
    width: 3,
    height: 80
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.571429, 341.333333)",
    id: "book/junior/landscape-copy-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-16",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    transform: "translate(42.000000, 32.500000) rotate(90.000000) translate(-42.000000, -32.500000) ",
    points: "74 74 10 74 10 -9 74 -9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 4.41666667,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 7,
    y: 22.2142857,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 7,
    y: 40.0119048,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 7,
    y: 57.8095238,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 12,
    y: 0,
    width: 2,
    height: 65
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(662.857143, 114.500000)",
    id: "book/junior/portrait"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.500000, 42.000000) rotate(-270.000000) translate(-32.500000, -42.000000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-16",
    strokeOpacity: 0.25,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.04,
    fill: "#000000",
    points: "65 84 1 84 1 1 65 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/spiral/red",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#562C2C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    x: 4,
    y: 81,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    x: 4,
    y: 77,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    x: 4,
    y: 73,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    x: 4,
    y: 69,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    x: 4,
    y: 65,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    x: 4,
    y: 61,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    x: 4,
    y: 57,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 4,
    y: 53,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 4,
    y: 49,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 4,
    y: 45,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 4,
    y: 41,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 4,
    y: 37,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 4,
    y: 33,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 4,
    y: 29,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 4,
    y: 25,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 4,
    y: 21,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 4,
    y: 17,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 4,
    y: 13,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 4,
    y: 9,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 4,
    y: 5,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 1,
    width: 6,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(784.571429, 108.666667)",
    id: "book/junior/portrait-copy-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-16",
    strokeOpacity: 0.3,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.06,
    fill: "#000000",
    points: "65 84 1 84 1 1 65 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 6,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 7,
    y: 29,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 7,
    y: 52,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 7,
    y: 75,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 12,
    y: 0,
    width: 2,
    height: 84
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.714286, 152.666667)",
    id: "book/half/portrait-copy-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    strokeOpacity: 0.25,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.04,
    fill: "#000000",
    transform: "translate(42.000000, 64.500000) rotate(90.000000) translate(-42.000000, -64.500000) ",
    x: -22,
    y: 23,
    width: 128,
    height: 83
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 9.75,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 7,
    y: 45.0714286,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 7,
    y: 80.3928571,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 7,
    y: 115.714286,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 12,
    y: 0,
    width: 2,
    height: 129
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(961.214286, 300.000000)",
    id: "book/tall/portrait-copy-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    points: "65 167 1 167 1 1 65 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#562C2C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/japanese/red",
    transform: "translate(0.466667, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.53333333,
    y: 13,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 6.53333333,
    y: 59,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 6.53333333,
    y: 105,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 6.53333333,
    y: 151,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 11.1333333,
    y: 0,
    width: 2,
    height: 168
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 1.000000)",
    id: "book/full/portrait"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    points: "1 1 129 1 129 167 1 167 1 31.0158824"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-8.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 0,
    y: 154,
    width: 16,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 0,
    y: 138,
    width: 16,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 0,
    y: 122,
    width: 16,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 106,
    width: 16,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 0,
    y: 90,
    width: 16,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 74,
    width: 16,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 58,
    width: 16,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 0,
    y: 42,
    width: 16,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 26,
    width: 16,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 10,
    width: 16,
    height: 4,
    rx: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648.642857, 234.333333)",
    id: "book/full/portrait-copy-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    strokeOpacity: 0.3,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.06,
    fill: "#000000",
    points: "1 1 129 1 129 167 1 167 1 31.0158824"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-8.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7.07142857,
    y: 4,
    width: 3,
    height: 160
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(295.285714, 1.000000)",
    id: "book/full/landscape-copy-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeOpacity: 0.3,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.06,
    fill: "#000000",
    transform: "translate(84.000000, 65.000000) rotate(90.000000) translate(-84.000000, -65.000000) ",
    x: 20,
    y: -18,
    width: 128,
    height: 166
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/stitch/red",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#562C2C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 3.0952381,
    width: 3,
    height: 123.809524
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(986.857143, 1.000000)",
    id: "book/half/landscape-copy-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    transform: "translate(65.000000, 43.000000) rotate(90.000000) translate(-65.000000, -43.000000) ",
    points: "106.5 -21 106.5 107 23.5 107 23.5 -21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/stitch/red",
    transform: "translate(-7.000000, 0.500000)",
    fill: "#0E9594"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 2.02380952,
    width: 3,
    height: 80.952381
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 408.000000)",
    id: "book/tall/portrait-copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    strokeOpacity: 0.25,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.04,
    fill: "#000000",
    points: "65 167 1 167 1 1 65 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/coptic-cover/red",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#562C2C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 15,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 7,
    y: 115,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 7,
    y: 33,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 7,
    y: 133,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 7,
    y: 51,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 7,
    y: 151,
    width: 7,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(470.857143, 275.000000)",
    id: "book/half/portrait"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.000000, 64.500000) rotate(-270.000000) translate(-42.000000, -64.500000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    strokeOpacity: 0.3,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.06,
    fill: "#000000",
    transform: "translate(42.000000, 64.500000) rotate(90.000000) translate(-42.000000, -64.500000) ",
    x: -22,
    y: 23,
    width: 128,
    height: 83
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    x: 4,
    y: 124.928571,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    x: 4,
    y: 118.785714,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    x: 4,
    y: 112.642857,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    x: 4,
    y: 106.5,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    x: 4,
    y: 100.357143,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    x: 4,
    y: 94.2142857,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    x: 4,
    y: 88.0714286,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 4,
    y: 81.9285714,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 4,
    y: 75.7857143,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 4,
    y: 69.6428571,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 4,
    y: 63.5,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 4,
    y: 57.3571429,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 4,
    y: 51.2142857,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 4,
    y: 45.0714286,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 4,
    y: 38.9285714,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 4,
    y: 32.7857143,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 4,
    y: 26.6428571,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 4,
    y: 20.5,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 4,
    y: 14.3571429,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 4,
    y: 8.21428571,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 2.07142857,
    width: 6,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(670.857143, 446.000000)",
    id: "book/full/landscape-copy-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    transform: "translate(84.000000, 65.000000) rotate(90.000000) translate(-84.000000, -65.000000) ",
    x: 20,
    y: -18,
    width: 128,
    height: 166
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#0E9594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/japanese/red",
    transform: "translate(0.466667, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.53333333,
    y: 9.83333333,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 6.53333333,
    y: 45.4285714,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 6.53333333,
    y: 81.0238095,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 6.53333333,
    y: 116.619048,
    width: 6.53333333,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 11.1333333,
    y: 0,
    width: 2,
    height: 130
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.000000, 222.500000)",
    id: "book/full/landscape"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.500000, 65.000000) rotate(-270.000000) translate(-83.500000, -65.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeOpacity: 0.3,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.06,
    fill: "#000000",
    transform: "translate(84.000000, 65.000000) rotate(90.000000) translate(-84.000000, -65.000000) ",
    x: 20,
    y: -18,
    width: 128,
    height: 166
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/spiral/red",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#0E9594"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    x: 4,
    y: 125.904762,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    x: 4,
    y: 119.714286,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    x: 4,
    y: 113.52381,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    x: 4,
    y: 107.333333,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    x: 4,
    y: 101.142857,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    x: 4,
    y: 94.952381,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    x: 4,
    y: 88.7619048,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 4,
    y: 82.5714286,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 4,
    y: 76.3809524,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 4,
    y: 70.1904762,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 4,
    y: 64,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 4,
    y: 57.8095238,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 4,
    y: 51.6190476,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 4,
    y: 45.4285714,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 4,
    y: 39.2380952,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 4,
    y: 33.047619,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 4,
    y: 26.8571429,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 4,
    y: 20.6666667,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 4,
    y: 14.4761905,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 4,
    y: 8.28571429,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 2.0952381,
    width: 6,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(941.928571, 459.500000)",
    id: "book/tall/portrait-copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.500000, 84.000000) rotate(-270.000000) translate(-32.500000, -84.000000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    points: "65 167 1 167 1 1 65 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 4,
    width: 3,
    height: 160
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(299.142857, 447.000000)",
    id: "book/half/portrait-copy-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    strokeOpacity: 0.25,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.04,
    fill: "#000000",
    transform: "translate(42.000000, 64.500000) rotate(90.000000) translate(-42.000000, -64.500000) ",
    x: -22,
    y: 23,
    width: 128,
    height: 83
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/stitch/red",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#0E9594"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 3.07142857,
    width: 3,
    height: 122.857143
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(435.714286, 492.000000)",
    id: "book/junior/portrait-copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-16",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    points: "65 84 1 84 1 1 65 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/coptic-cover/red",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#562C2C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 7,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 7,
    y: 57,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 7,
    y: 16,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 7,
    y: 66,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 7,
    y: 25,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 7,
    y: 75,
    width: 7,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(664.071429, 11.000000)",
    id: "book/junior/landscape-copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.000000, 32.500000) rotate(-270.000000) translate(-42.000000, -32.500000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-16",
    strokeOpacity: 0.3,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.06,
    fill: "#000000",
    transform: "translate(42.000000, 32.500000) rotate(90.000000) translate(-42.000000, -32.500000) ",
    points: "74 74 10 74 10 -9 74 -9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 1.54761905,
    width: 3,
    height: 61.9047619
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440.142857, 169.000000)",
    id: "book/tall/landscape-copy-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    strokeOpacity: 0.3,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.06,
    fill: "#000000",
    transform: "translate(83.000000, 33.000000) rotate(90.000000) translate(-83.000000, -33.000000) ",
    points: "115 116 51 116 51 -50 115 -50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#F25546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 1.57142857,
    width: 3,
    height: 62.8571429
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.571429, 490.000000)",
    id: "book/half/landscape"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    transform: "translate(65.000000, 43.000000) rotate(90.000000) translate(-65.000000, -43.000000) ",
    points: "106.5 -21 106.5 107 23.5 107 23.5 -21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/disc-6/red",
    transform: "translate(-7.000000, 0.500000)",
    fill: "#0E9594"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 0,
    y: 75.9166667,
    width: 14,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 61.75,
    width: 14,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 47.5833333,
    width: 14,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 0,
    y: 33.4166667,
    width: 14,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 19.25,
    width: 14,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 5.08333333,
    width: 14,
    height: 4,
    rx: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092.500000, 427.500000)",
    id: "book/full/landscape-copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.500000, 65.000000) rotate(-270.000000) translate(-83.500000, -65.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 2,
    fillOpacity: 0.02,
    fill: "#000000",
    transform: "translate(84.000000, 65.000000) rotate(90.000000) translate(-84.000000, -65.000000) ",
    x: 20,
    y: -18,
    width: 128,
    height: 166
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-thumbnail/coptic-cover/red",
    transform: "translate(-7.000000, 0.000000)",
    fill: "#562C2C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 11.3809524,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 7,
    y: 88.7619048,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 7,
    y: 25.3095238,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 7,
    y: 102.690476,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 7,
    y: 39.2380952,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 7,
    y: 116.619048,
    width: 7,
    height: 2
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebooks);
export default __webpack_public_path__ + "static/media/notebooks.78530325.svg";
export { ForwardRef as ReactComponent };